import { getCalendarGridEventTone } from '../config/calendarPage.config';
import React from 'react';
import { CalendarDays } from '../../../shared/assets/AppIcons';
import { AssetIcon } from '../../../shared/assets';
import { CreateFormCancelButton, CreateFormDialog } from '../../../shared/components/CreateFormDialog';
import { CALENDAR_EVENT_TYPE_OPTIONS } from '../utils/calendar.constants';
import { getCalendarEventForm } from '../config/calendarEventTypes';

export default function CreateEventTypeDialog({ open, onOpenChange, onSelectType, eventTypes = CALENDAR_EVENT_TYPE_OPTIONS }) {
  return <CreateFormDialog
    open={open} onOpenChange={onOpenChange} icon={CalendarDays}
    title="Nuovo evento" description="Seleziona il tipo di evento da creare"
    footer={<CreateFormCancelButton onClick={() => onOpenChange(false)} />}
  >
    <div className="grid grid-cols-2 gap-4 py-6" aria-label="Categorie evento">
      {eventTypes.map(({ value, label }) => {
        const config = getCalendarEventForm(value);
        return <button key={value} type="button" aria-label={label}
          className={`calendar-event-type-card calendar-event-tone--${getCalendarGridEventTone(value)}`}
          onClick={() => onSelectType(value)}>
          <span className="flex flex-col items-center gap-3">
            <span className="calendar-event-type-card__icon">
              <AssetIcon name={config.iconKey || 'nav.calendar'} size={32} />
            </span>
            <span className="text-center">
              <span className="block font-bold text-lg">{label}</span>
              <span className="calendar-event-type-card__description">{config.description}</span>
            </span>
          </span>
        </button>;
      })}
    </div>
  </CreateFormDialog>;
}
